import { render, staticRenderFns } from "./AddCounterpart.vue?vue&type=template&id=5478799e"
import script from "./AddCounterpart.vue?vue&type=script&lang=js"
export * from "./AddCounterpart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports